import { SVGProps } from 'react';

export const CloseWhiteIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.8493 25.8495C25.1109 26.1123 25.535 26.1123 25.7965 25.8495C26.0581 25.5866 26.0581 25.1605 25.7965 24.8976L21.4124 20.4923L25.8504 16.0327C26.112 15.7699 26.112 15.3438 25.8504 15.0809C25.5888 14.8181 25.1647 14.8181 24.9032 15.0809L20.4652 19.5404L16.0272 15.0809C15.7656 14.8181 15.3415 14.8181 15.08 15.0809C14.8184 15.3438 14.8184 15.7699 15.08 16.0327L19.518 20.4923L15.1338 24.8976C14.8723 25.1605 14.8723 25.5866 15.1338 25.8495C15.3954 26.1123 15.8195 26.1123 16.0811 25.8495L20.4652 21.4441L24.8493 25.8495Z"
                fill="#fff"
            />
        </svg>
    );
};
